import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { authSlice } from "./auth/authSlice";
import { commercialSlice } from "./commercial/commercialSlice";
import { configurationSlice } from "./configuration/configurationSlice";
import { gateEntrySlice } from "./gate-entry/gateEntrySlice";
import { insightsSlice } from "./insights/insightsSlice";
import { managementSlice } from "./management/managementSlice";
import { notificationSlice } from "./notifications/notificationSlice";
import { cameraSlice } from "./camera/cameraSlice";
import { settingsSlice } from "./settings/settingsSlice";
import { vehicleSlice } from "./vehicle/vehicleSlice";
import { wareHouseSlice } from "./warehouse/wareHouseSlice";
import { workOrderSlice } from "./work-order/workOrderSlice";
import { yardSlice } from "./yard/yardSlice";
import { hqDashboardSlice } from "./hq-dashboard/hqDashboardSlice";
/**
 * @link https://redux-toolkit.js.org/tutorials/typescript Redux-Toolkit Typescript Docs
 */
export const store = configureStore({
  reducer: {
    settings: settingsSlice.reducer,
    auth: authSlice.reducer,
    management: managementSlice.reducer,
    vehicle: vehicleSlice.reducer,
    workorder: workOrderSlice.reducer,
    gate_entry: gateEntrySlice.reducer,
    configuration: configurationSlice.reducer,
    commercial: commercialSlice.reducer,
    warehouse: wareHouseSlice.reducer,
    yard: yardSlice.reducer,
    insights: insightsSlice.reducer,
    notifications: notificationSlice.reducer,
    camera: cameraSlice.reducer,
    dashboard: hqDashboardSlice.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type IActionMeta<T = void> = {
  requestId: string;
  requestStatus: "pending" | "fulfilled" | "rejected";
  arg?: T;
  aborted?: boolean;
  condition?: boolean;
  rejectedWithValue?: boolean;
};
